/** Keep Google's incoming linker available while the club's tag loads asynchronously. */
export const preserveGoogleLinker = (
  path: string,
  currentUrl: string | undefined
): string => {
  if (!currentUrl) return path;

  const current = new URL(currentUrl);
  const destination = new URL(path, current);
  const currentClubPath = current.pathname.match(
    /^\/patron\/club\/[^/]+(?=\/|$)/
  )?.[0];
  const destinationClubPath = destination.pathname.match(
    /^\/patron\/club\/[^/]+(?=\/|$)/
  )?.[0];
  const linker = current.searchParams.get("_gl");

  if (
    !linker ||
    !currentClubPath ||
    currentClubPath !== destinationClubPath ||
    current.origin !== destination.origin ||
    destination.searchParams.has("_gl")
  ) {
    return path;
  }

  // Carry only the linker, never login tokens, personal data, or other query parameters.
  // Preserve the router's encoding of existing parameters and fragment verbatim.
  const hashIndex = path.indexOf("#");
  const pathnameAndSearch = hashIndex < 0 ? path : path.slice(0, hashIndex);
  const hash = hashIndex < 0 ? "" : path.slice(hashIndex);
  const separator = pathnameAndSearch.includes("?") ? "&" : "?";
  return `${pathnameAndSearch}${separator}_gl=${encodeURIComponent(
    linker
  )}${hash}`;
};
